import DOMPurify from 'dompurify';

// CMS wysiwyg content rendered via v-html goes through here; editors are
// trusted, but the sanitizer keeps a pasted script or event handler out.
export const sanitizeHtml = (html) => DOMPurify.sanitize(html || '', { USE_PROFILES: { html: true } });

const COLOR_PROPERTIES = ['color', 'background-color', 'background'];

const stripStyleProperties = (html, properties) => {
  if (!html) return '';

  const holder = document.createElement('div');
  holder.innerHTML = html;

  holder.querySelectorAll('[style]').forEach((element) => {
    properties.forEach((property) => element.style.removeProperty(property));
    if (!element.getAttribute('style')) element.removeAttribute('style');
  });

  return holder.innerHTML;
};

// Editors colour text inside the wysiwyg to draw attention: Whoon red on a
// heading, a one-off purple or green on a paragraph, once a highlight. Every one
// of those is a span carrying an inline style. The panel is a compact dialog
// with its own type scale, where that palette reads as noise instead of
// emphasis, so all of it comes out and the text inherits the panel's own colours
// (WHN-2136).
//
// Only the colour declarations go, not the whole style attribute: 88% of the
// construction-number descriptions carry a style that is nothing but
// "margin-left: 40px" indentation, and dropping that would reformat almost every
// description. Font sizes stay for the same reason.
//
// Runs on already-sanitised markup, so the innerHTML round-trip introduces
// nothing that sanitizeHtml did not already allow.
export const stripTextColors = (html) => stripStyleProperties(html, COLOR_PROPERTIES);

export const stripFontSizes = (html) => stripStyleProperties(html, ['font-size']);

// The detail panels are dialogs over a filtered result list. An editor's link
// inside the wysiwyg would navigate the page away underneath them and lose that
// list, so links open in a new tab instead. 32 of the 47 project intros carry
// one, mostly to the project page the panel previews.
//
// Runs on already-sanitised markup, so the innerHTML round-trip introduces
// nothing that sanitizeHtml did not already allow.
export const openLinksInNewTab = (html) => {
  if (!html) return '';

  const holder = document.createElement('div');
  holder.innerHTML = html;

  holder.querySelectorAll('a[href]').forEach((link) => {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener');
  });

  return holder.innerHTML;
};
